import { Link } from 'react-router-dom'
import { RoutePaths } from 'src/routes/routePaths'
import './SubscriptionPriceRenewalInfoBanner.scss'
import { useSelector } from 'react-redux'
import { CuiIcon } from 'front-lib'
import {
  getAllowRecommendationSelector,
  getTotalDiscount,
  getTotalPlanMeals
} from '../../../../../../../redux-api-bridge/order/selectors'
import { useBoxOrderingModel } from '../../../../../../../hooks/useBoxOrderingModel'
import { selectedDeliveryCutoffMomentSelector } from '../../../../../../../components/DeliveryCard/selectors'
import { fromDaylightTzToStandardTzLabel } from '../../../../../../../hooks/useDeliveryTimeZone'

const messageMap = {
  regular: price =>
    `Enjoy your discounted rate! After it ends, your subscription will automatically renew at $${price} per week. Pause or cancel anytime in your`,
  noDiscount: 'Pause or cancel anytime in your',
  bom: price =>
    `Your subscription will automatically renew at $${price} per week. Auto renewal may result in meals being selected that increase the weekly charge of $${price} by an amount not to exceed $5. Pause or cancel anytime in your`
}

export function SubscriptionPriceRenewalInfoBanner() {
  const totalDiscount = useSelector(getTotalDiscount)
  const { isBOM } = useBoxOrderingModel()
  const totalPlanMeals = useSelector(getTotalPlanMeals)
  const isAutoRenewalEnabled = useSelector(getAllowRecommendationSelector)
  const cutoff = useSelector(selectedDeliveryCutoffMomentSelector)

  if (!isAutoRenewalEnabled) {
    return null
  }

  let message
  if (isBOM) {
    message = messageMap.bom(totalPlanMeals)
  } else if (totalDiscount) {
    message = messageMap.regular(totalPlanMeals)
  } else {
    message = messageMap.noDiscount
  }

  return (
    <>
      <div className="discounted-rate-info-banner">
        {message}
        <Link to={RoutePaths.ACCOUNT} className="account-settings-link">
          {' '}
          Account Settings
        </Link>
        .
      </div>
      <div className="cancel-subscription-info-banner">
        <span className="bar" />
        <CuiIcon name="infoIcon" role="icon" />
        <span className="text">
          You can always skip or reschedule your weekly delivery before your
          order deadline:
          <br />
          <b>
            {cutoff.format('dddd[s] [at] H a')}{' '}
            {fromDaylightTzToStandardTzLabel(cutoff.format('z'))}
          </b>
        </span>
      </div>
    </>
  )
}
